import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App.tsx';
import { PostHogWrapper } from './components/PostHogWrapper/index.ts';
import './sentry';

import './styles/index.scss';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <PostHogWrapper>
        <App />
      </PostHogWrapper>
    </BrowserRouter>
  </StrictMode>
);
